import {Inject, Injectable} from '@angular/core';
import {OAuthEvent, OAuthService} from 'angular-oauth2-oidc';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import {environment, CustomEnvironment, setApiOverrides} from '../../environments/environment';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {HttpErrorHandlerService, HandleError} from './http-error-handling.service';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'my-auth-token'
  })
};

@Injectable()
export class CommunicationsService {
  private handleError: HandleError;

  constructor(private oauthService: OAuthService,
              private http: HttpClient,
              httpErrorHandler: HttpErrorHandlerService,
              @Inject(CustomEnvironment) customEnvironment: any) {
    setApiOverrides(customEnvironment);

    this.oauthService.events.subscribe((event: OAuthEvent) => {
      const tokenUpdatedEvents: any = ['token_refreshed', 'token_received', 'silently_refreshed'];
      if (tokenUpdatedEvents.includes(event.type)) {
        httpOptions.headers = httpOptions.headers.set('Authorization', this.oauthService.authorizationHeader());
      }
    });

    httpOptions.headers = httpOptions.headers.set('Authorization', this.oauthService.authorizationHeader());
    this.handleError = httpErrorHandler.createHandleError('LookupService');
  }

  makePhoneCall(type: string, appId: number, data: any) {
    return this.http.post(`${environment.api.communications}/phone/call`, data, httpOptions)
      .pipe(
        catchError(this.handleError('makePhoneCall', []))
      );
  }

  make3cxPhoneCall(type: string, appId: number, data: any) {
    return this.http.post(`${environment.api.communications}/phone/call/3cx`, data, httpOptions)
      .pipe(
        catchError(this.handleError('make3cxPhoneCall', []))
      );
  }

  makeNecPhoneCall(type: string, appId: number, data: any) {
    return this.http.post(`${environment.api.communications}/phone/call/nec`, data, httpOptions)
      .pipe(
        catchError(this.handleError('makeNecPhoneCall', []))
      );
  }

  sendSms(data: any) {
    return this.http.post(`${environment.api.communications}/sms`, data, httpOptions)
      .pipe(
        catchError(this.handleError('sendSms', []))
      );
  }

  sendEmail(data: any) {
    const body = JSON.stringify(data);
    return this.http.post(`${environment.api.communications}/email`, body, httpOptions)
      .pipe(
        catchError(this.handleError('sendEmail', []))
      );
  }


  sendMessage(data: any){
    return this.http.post(`${environment.api.communications}/message`, data, httpOptions)
    .pipe(
      catchError(this.handleError('sendMessage', []))
    );
  }
}
